import axios from 'axios';
import React, { useState, useRef, useEffect } from "react";
import { MaterialReactTable } from 'material-react-table';
import { Oval } from 'react-loader-spinner';
import {
    Box,
    Typography,
    Container,
    Tooltip,
    Switch
} from '@mui/material';

import "../../styles/Admin-ui/Admin-DoctorsList.css";
import { API_DETAILS, COOKIE_KEYS, USER_TYPES } from '../../App';
import AdminSideBar from './Admin-SideBar';
import AdminPopUps from './Admin-PopUps';
import Cookies from "js-cookie";
import Youroheader from '../Youro-header';
import "../../styles/Admin-ui/Admin-PopUps.css";

import {  useNavigate  } from 'react-router-dom';
import { toast } from '../../utils/toast';
import { errorMessage } from '../../utils/errorMessage';
// A module-level array of made-up doctors used to sit here. Nothing rendered
// it, but every fetch pushed the real records onto it, so it grew for as long as
// the tab stayed open.
const AdminDoctorsList = () => {
    
    const [tableData, setTableData] = useState([]);
    const [renderAdmin, canRenderAdmin] = useState(false);
    const [renderapidata,cannotrenderapidata]=useState(false);
    const isRendered = useRef(false);
    let count = 0;
    const [authContext, setAuthContext] = useState(''); // default zero. After login if ADMIN -> set('ADMIN') else if 'ASSITANT' -> set('ASSITANT')


    useEffect(() => {
        count += 1;
        if (!isRendered.current) {
            fetchData();
            isRendered.current = true;
        }
        else {
        }
    }, []);


    const fetchData = async () => {
        let type = USER_TYPES.doctor;
        Cookies.get(COOKIE_KEYS.userType) == 'ADMIN' ? setAuthContext('ADMIN') : (Cookies.get(COOKIE_KEYS.userType) == 'ASSITANT' ? setAuthContext('ASSITANT') : navigate('/login'))
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/getAllUsers/${type}`;
        try {
            const res = await axios.get(url, config);
            canRenderAdmin(true); 
            setTableData(res.data);
        }
        catch (err) {
             //setfetcher true
            cannotrenderapidata(true);
        }
    };

    const handleApproveRenderAndChange = (cell = { emptyRow: true }, isChange = false) => {
        // console.log('cell => ' + JSON.stringify(cell) + " , " + JSON.stringify(tableData));
        if (isChange) {
            for (let i = 0; i < tableData.length; i++) {
                if (cell.row.original.userId == tableData[i].userId) {
                    const nextStatus = cell.row.original.status === 'APPROVED' ? 'PENDING' : 'APPROVED';
                    tableData[i]['status'] = nextStatus;
                    setTableData([...tableData]);
                    isRendered.current = true;
                    updateDoctorStatus(cell.row.original, nextStatus);
                }
            }
        }
    }

    const updateDoctorStatus = async (rowData, nextStatus) => {
        const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/provider/updateProfile`;
        try {
            // Only the id and the field being changed: sending the whole table row
            // back means sending whatever the list happened to be showing, and this
            // endpoint applies every field it is given.
            await axios.put(url, { userId: rowData.userId, status: nextStatus });
            toast.success(nextStatus === 'APPROVED' ? "Provider approved." : "Provider set back to pending.");
        }
        catch (err) {
            toast.error(errorMessage(err, "We couldn't change that provider's status. Please try again."));
        }
        // Either way, show what the server actually holds rather than the row the
        // switch moved optimistically.
        fetchData();
    }

    const columns = authContext=='ADMIN' ?
    [
        // {
        //     accessorKey: 'userId',
        //     header: 'ID',
        //     enableColumnOrdering: false,
        //     enableEditing: false,
        //     size: 50,
        // },
        {
            accessorKey: 'firstName',
            header: 'First Name',
        },
        {
            accessorKey: 'lastName',
            header: 'Last Name',
        },
        {
            accessorKey: 'state',
            header: 'State',
        },
        {
            header: "Status",
            accessorKey: "status",
            Cell: ({ cell }) => (
                <Tooltip arrow placement="right" title="Approve">
                    <Switch
                        checked={cell.row.original.status == 'APPROVED'}
                        onChange={() => handleApproveRenderAndChange(cell, true)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />
                </Tooltip>
            ),
            size: 20,
        }
    ] :
    [
        // {
        //     accessorKey: 'userId',
        //     header: 'ID',
        //     enableColumnOrdering: false,
        //     enableEditing: false,
        //     size: 50,
        // },
        {
            accessorKey: 'firstName',
            header: 'First Name',
        },
        {
            accessorKey: 'lastName',
            header: 'Last Name',
        },
        {
            accessorKey: 'state',
            header: 'State',
        }
    ];


    const navigate = useNavigate();

    const handleClick = (row) => {

        navigate('/admin-view-doctor', { 
            state: { 
                userId: row.original.userId,
                firstName: row.original.firstName,
                lastName: row.original.lastName,
                email: row.original.email,
                phone1: row.original.phone1,
                address: row.original.address,
                city: row.original.city,
                zipCode: row.original.zipCode,
                specialty: row.original.specialty,
                status: row.original.status,
                userType: row.original.userType,
                state: row.original.state,
                profileImageURL: row.original.profileImageURL,
                license: row.original.license,
                username: row.original.username,
                gender: row.original.gender,
                dateOfBirth: row.original.dateOfBirth
            }

        });
    };
  

    
    return (
        <div>
            {
                    <div className='hm'>
                        <div className='sidebar'>
                            <AdminSideBar data={'admin-doctors'} />
                        </div>
                        <div className="admin-ui-table">
                            <div className='header' style={{marginLeft: '15px'}}>
                                {/* <h1 style={{marginLeft: '15px'}}>youro</h1> */}
                                 <Youroheader/>
                            </div>
                        {renderAdmin == true && tableData && tableData.length > 0 ? (
                            <MaterialReactTable
                                displayColumnDefOptions={{
                                    'mrt-row-actions': {
                                        muiTableHeadCellProps: {
                                            align: 'center',
                                        },
                                        size: 120,
                                    },
                                }}
                                columns={columns}
                                data={tableData}
                                enableStickyHeader
                                enableColumnOrdering
                                enableRowActions={authContext=='ADMIN'}
                                enableEditing={authContext=='ADMIN'}
                                // enableRowNumbers

                                muiTableContainerProps={{ sx: { maxHeight: window.innerHeight } }}
                                positionActionsColumn='last'
                                renderRowActions={ ({ row }) => (
                                    authContext=='ADMIN' &&
                                    <Box sx={{ display: 'flex', gap: '1rem' }}>
                                        <Tooltip arrow placement="right" title="Delete" >
                                            <AdminPopUps data={{ 'action': 'delete-doctor', 'step': 1, 'rowData': row.original }} />
                                        </Tooltip>
                                    </Box>
                                )}
                                renderDetailPanel={({ row }) => (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            margin: 'auto',
                                            gridTemplateColumns: '1fr 1fr',
                                            width: '100%',
                                            padding: '0',
                                            maxWidth: '100%'
                                        }}
                                    >
                                        <Container maxWidth={false} sx={{ padding: '0', margin: '0px', maxWidth: '100%' }}>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <Typography>Address: {row.original.address}</Typography>
                                                    <Typography>City: {row.original.city}</Typography>
                                                    <Typography>State: {row.original.state}</Typography>
                                                    {/* <Typography>Country: {row.original.country}</Typography> */}
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-12' style={{ textAlign: 'end' }}>
                                                    <button onClick={() => handleClick(row)} className='view-more-class' >
                                                        View More {'>>'}
                                                    </button>
                                                </div>
                                            </div>
                                        </Container>
                                    </Box>
                                )}
                                muiTableBodyProps={{
                                    sx: () => ({
                                        // '& tr:nth-of-type(even)': {
                                        //     backgroundColor: "yellow",
                                        // },
                                        '& tr:nth-of-type(odd)': {
                                            backgroundColor: "lightgray",
                                            // border: '2px solid',
                                            // borderColor: 'black'
                                        },
                                    }),
                                }}
                            />
                        
                          ):  renderapidata? (<div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',width: "98%", borderRadius: '10px', height: '70vh',}}>
                        We couldn't load this list. Refresh to try again.
                    </div>):!renderAdmin ? ( <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',width: "98%", borderRadius: '10px', height: '70vh',}} ><Oval/></div>):
                          renderAdmin==true && tableData && tableData.length == 0 && <>
                     <div style={{ textAlign:'center',width: "98%", borderRadius: '10px', height: '70vh' }}>
                         Nothing here yet.
                     </div>
                       </>
                        }
                        </div>
                       
                    </div>


                // </>
            }
            {
                // tableData && tableData.length == 0 && <>
                //     <div style={{ width: "98%", backgroundColor: 'white', borderRadius: '10px', height: '200px' }}>
                //         Nothing here yet.
                //     </div>
                // </>
            } 
         
        </div>
    );

};

export default AdminDoctorsList;